import {Environment} from '@environments/environment.model';

export const environment: Environment = {
  production: true,
  backend: {
    host: window['__config'].backend.baseUrl,
    context: 'pd',
    version: 'v2',
  },
  oidc: {
    clientId: window['__config'].oidc.clientId,
    redirectUri: window['__config'].oidc.redirectUri,
    wcHost: window['__config'].oidc.wcHost,
  },
  piwik: {
    baseUrl: window['__config']['piwikUrl'],
    siteId: window['__config']['piwikSiteId'],
    activated: window['__config']['piwikActive'],
  },
  wba: {
    underConstruction: window['__config']['underConstruction'],
    underConstructionUntil: window['__config']['underConstructionUntil']
  },
  haBaseUrl: window['__config']['haBaseUrl'],
  vaem: {
    mockActive: window['__config']['vaemMockActive'],
    apiUrl: window['__config']['vaemApiUrl'],
    clientUrl: window['__config']['vaemClientUrl']
  },
  feedbackScriptUrl: window['__config']['feedbackScriptUrl'],
  leistungspostfachUrl: window['__config']['leistungspostfachUrl'],
  vereinfachterAntragPruefungszeitraum: {
    von: '2020-09-30',
    bis: '2022-07-31'
  },
  devModules: [], // eg. StoreDevModule/Ngxs,
  isDebuggingEnabled: window['__config']['isDebuggingEnabled'],
  isProd: window['__config']['isProd'],

  headerKomponenteScriptUrlEsm: window['__config'].headerKomponenteScriptUrlEsm,
  oauthWcKomponenteScriptUrlEsm: window['__config'].oauthWcKomponenteScriptUrlEsm,
  oauthWcKomponenteScriptUrl: window['__config'].oauthWcKomponenteScriptUrl,
  oauthWcKomponenteAuthority: window['__config'].oauthWcKomponenteAuthority,
  feedbackKomponenteScriptUrl: window['__config'].feedbackKomponenteScriptUrl,
};
